import React from "react";

import { Tooltip } from "@material-ui/core";
import AcceptedIcon from "@material-ui/icons/CheckCircleOutline";
import AcceptedStoredIcon from "@material-ui/icons/OfflinePinOutlined";
import VerifiedStoredIcon from "@material-ui/icons/ErrorOutline";
import RejectedIcon from "@material-ui/icons/HighlightOff";
import SecondaryReviewIcon from "@material-ui/icons/RotateRight";
import { green, orange, red } from "@material-ui/core/colors";

import {
  AdviceCompletedIcon,
  AdviceErrorIcon,
  AdviceProcessingIcon,
  RejectIcon,
  RemoveIcon,
  WarningIcon,
} from "../../../components/common/iconography";
import { InboundState, InboundStatus } from "../../../utils/constants";

export const InboundStateIcon = ({ record, ...props }) => {
  if (!record) return null;
  else
    //  TODO: add advice failed icon
    return record.status === InboundStatus.ADVICE_PROCESSING ? (
      <Tooltip title="Advice Processing" placement="right" arrow>
        <AdviceProcessingIcon style={{ color: orange[600] }} />
      </Tooltip>
    ) : record.status === InboundStatus.ADVICE_FAILED ? (
      <Tooltip title="Advice Failed" placement="right" arrow>
        <AdviceErrorIcon style={{ color: red[600] }} />
      </Tooltip>
    ) : record.status === InboundStatus.ADVICE_REVIEW ? (
      <Tooltip title="Advice Review" placement="right" arrow>
        <AdviceCompletedIcon style={{ color: green[600] }} />
      </Tooltip>
    ) : record.status === InboundStatus.ADVICE_REJECTED ? (
      <Tooltip title="Advice Rejected" placement="right" arrow>
        <RejectIcon style={{ color: red[700] }} />
      </Tooltip>
    ) : record.verificationRequired === "true" ? (
      <Tooltip title="Approval Required" placement="right" arrow>
        <WarningIcon style={{ color: orange[600] }} />
      </Tooltip>
    ) : record.verificationRequired === "resolved" &&
      record.state === InboundState.PROCESS_INVENTORY ? (
      <Tooltip title="Verified & Accepted" placement="right" arrow>
        <WarningIcon style={{ color: green[600] }} />
      </Tooltip>
    ) : record.verificationRequired === "resolved" &&
      record.state === InboundState.COMPLETED ? (
      <Tooltip title="Verified, Accepted, Stored" placement="right" arrow>
        <VerifiedStoredIcon style={{ color: green[600] }} />
      </Tooltip>
    ) : (!record.verificationRequired ||
        record.verificationRequired === "false") &&
      record.state === InboundState.PROCESS_INVENTORY ? (
      <Tooltip title="Accepted" placement="right" arrow>
        <AcceptedIcon style={{ color: green[600] }} />
      </Tooltip>
    ) : (!record.verificationRequired ||
        record.verificationRequired === "false") &&
      record.state === InboundState.COMPLETED ? (
      <Tooltip title="Accepted, Stored" placement="right" arrow>
        <AcceptedStoredIcon style={{ color: green[600] }} />
      </Tooltip>
    ) : record.state === InboundState.PROCESS_INVENTORY_REVIEW ? (
      <Tooltip title="Secondary Review" placement="right" arrow>
        <SecondaryReviewIcon style={{ color: green[700] }} />
      </Tooltip>
    ) : record.state === InboundState.APPROVE_INVENTORY_REVIEW ? (
      <Tooltip title="Review Approval Required" placement="right" arrow>
        <SecondaryReviewIcon style={{ color: red[700] }} />
      </Tooltip>
    ) : record.state === InboundState.REJECTED ? (
      <Tooltip title="Rejected" placement="right" arrow>
        <RejectedIcon style={{ color: red[700] }} />
      </Tooltip>
    ) : (
      <Tooltip title="Not Accepted" placement="right" arrow>
        <RemoveIcon color="disabled" />
      </Tooltip>
    );
};
